export const SITE_URL = typeof VITE_SITE_URL !== 'undefined'
  ? VITE_SITE_URL
  : 'https://litbuyspreadsheets.xyz';